import React from 'react';
import { BarChart3 } from 'lucide-react';

const PageHeader: React.FC<{ icon?: React.ReactNode; title: string; subtitle?: string; actions?: React.ReactNode }> = ({ icon, title, subtitle, actions }) => {
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div>
        <div className="flex items-center gap-3 mb-2">
          <div className="w-10 h-10 bg-sky-500 rounded-lg flex items-center justify-center">
            {icon ?? <BarChart3 className="w-6 h-6 text-white" />}
          </div>
          <div>
            <h1 className="text-3xl font-bold text-white">{title}</h1>
            {subtitle && <p className="text-slate-400">{subtitle}</p>}
          </div>
        </div>
      </div>

      {actions && (
        <div className="flex items-center gap-2">
          {actions}
        </div>
      )}
    </div>
  );
};

export default PageHeader;
